var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length > 0)?_c('v-carousel',_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":item}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }